import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {Part, PartType} from '../../../models/Part';
import Modal from '../../../../../components/modal';
import {SelectType} from './SelectType';
import {DetailPart} from './DetailPart';

interface OwnProps {
    onAdd: (part: Part) => void;
    onDismiss: () => void;
}

enum WizardSteps {
    TypeSelection,
    PartDetailing,
}

interface TypeSelectionStep {
    step: WizardSteps.TypeSelection;
}

interface PartDetailingStep {
    step: WizardSteps.PartDetailing;
    type: PartType;
}

type Step = TypeSelectionStep | PartDetailingStep;

export const AddPartWizard: FunctionComponent<OwnProps> = ({onAdd, onDismiss}) => {
    const [step, setStep] = useState<Step>({
        step: WizardSteps.TypeSelection,
    });

    function getContent(): JSX.Element {
        switch (step.step) {
            case WizardSteps.TypeSelection:
                return (
                    <SelectType
                        onSelect={(partType) => setStep({step: WizardSteps.PartDetailing, type: partType})}
                        onDismiss={onDismiss}
                    />
                );
            case WizardSteps.PartDetailing:
                return <DetailPart type={step.type} onAdd={onAdd} onDismiss={onDismiss} />;
        }
    }

    return (
        <Modal visible={true} onHide={onDismiss}>
            {getContent()}
        </Modal>
    );
};
